import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import { publicApi } from '../../services/api';
import { flattenSettings, getSettingValue } from '../../utils/settings';

export default function WhatsAppFloat() {
  const [phone, setPhone] = useState('');
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    publicApi.getSettings()
      .then(res => {
        const settings = res.data?.data || {};
        const flatSettings = flattenSettings(settings);
        setPhone(getSettingValue(flatSettings, ['contact_whatsapp', 'whatsapp_number'], '6287868782477'));
        setGreeting(getSettingValue(flatSettings, ['whatsapp_greeting', 'site_tagline'], 'Halo Klinnovac! Saya ingin bertanya tentang layanan pembersihan premium.'));
      })
      .catch(() => {
        // Fallback defaults
        setPhone('6287868782477');
        setGreeting('Halo Klinnovac! Saya ingin bertanya tentang produk dan layanan Anda.');
      });
  }, []);

  if (!phone) return null;

  const whatsappUrl = `https://wa.me/${phone.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(greeting)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-green-500 text-white px-4 py-3 rounded-full shadow-lg hover:bg-green-600 transition-all duration-300 hover:scale-105 hover:shadow-xl group"
      title="Chat via WhatsApp"
    >
      <MessageCircle size={24} className="group-hover:animate-bounce" />
      <span className="text-sm font-semibold hidden sm:inline">Chat WhatsApp</span>
    </a>
  );
}